import { ServiceRegistryLocale } from './types';

export type NumberValue = number | bigint;

export const formatNumber = (
  value: NumberValue,
  locale: ServiceRegistryLocale,
  options?: Intl.NumberFormatOptions,
): string => new Intl.NumberFormat(locale, options).format(value);

export const formatCurrency = (
  value: NumberValue,
  currency: string,
  locale: ServiceRegistryLocale,
  options?: Intl.NumberFormatOptions,
): string =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    ...options,
  }).format(value);

const pad = (value: number): string => String(value).padStart(2, '0');

export const formatUtcDate = (value: string | number | Date): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(
    date.getUTCDate(),
  )}`;
};

export const formatUtcDateTime = (
  value: string | number | Date,
  includeSeconds = true,
): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const time = `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
  const seconds = includeSeconds ? `:${pad(date.getUTCSeconds())}` : '';
  return `${formatUtcDate(date)} ${time}${seconds}Z`;
};
